import React from 'react'
import SvgWrapper from '../SvgWrapper'
import type { IllustrationProps } from './types'

const PhoneVsDesktopIllustration: React.FC<IllustrationProps> = ({ width = 152, height = 160 }) => (
  <SvgWrapper height={height} width={width} viewBox="0 0 152 160" fill="none">
    <g clipPath="url(#a)">
      <path
        d="M71.839 56.919a3.405 3.405 0 0 0-2.697 1.032 3.42 3.42 0 0 0-.942 2.734L57.222 65.84l5.373 3.296 9.601-5.402a3.43 3.43 0 0 0 2.098-1.242 3.441 3.441 0 0 0-.239-4.559 3.428 3.428 0 0 0-2.216-1.015ZM26.411 156.126h3.792l1.803-14.652-5.595.001v14.651Z"
        fill="#604134"
      />
      <path
        d="m25.444 154.886 7.467-.001c1.262 0 2.472.503 3.365 1.397a4.77 4.77 0 0 1 1.393 3.37v.155l-12.224.001v-4.922Z"
        fill="#020537"
        fillOpacity=".87"
      />
      <path d="M45.757 153.126h3.792l1.803-14.652-5.595.001v14.651Z" fill="#604134" />
      <path
        d="m44.79 154.886 7.467-.001c1.262 0 2.472.503 3.365 1.397a4.77 4.77 0 0 1 1.393 3.37v.155l-12.224.001v-4.922Z"
        fill="#020537"
        fillOpacity=".87"
      />
      <path
        d="m48.29 80.133 1.924 4.151 3.47 37.12-2.697 31.905h-6.308l-7.442-50.29-3.496 49.131-8.51-.344-1.634-66.61 24.693-5.063Z"
        fill="#2E35A8"
      />
      <path d="M28 47.03 37 50V37h-8.167L28 47.03Z" fill="#9E616A" />
      <path d="M35.5 40a8.5 8.5 0 1 0 0-17 8.5 8.5 0 0 0 0 17Z" fill="#9E616A" />
      <path
        d="m33.704 32.584 1.166 1.438 2.113-3.754s2.697.142 2.697-1.891c0-2.034 2.475-2.088 2.475-2.088s3.502-6.209-3.752-4.571c0 0-5.032-3.5-7.532-.508 0 0-7.672 3.92-5.476 10.75L29.043 39l.826-1.594s-.5-6.688 3.838-4.825l-.003.003Z"
        fill="#2F2E43"
      />
      <path
        d="m17.625 45.879 7.978-3.252 11.26.633 10.011 3.655 3.34 37.37c-8.71 4.764-17.531 6.065-26.507 2.657l-8.33-24.34 2.248-16.723Z"
        fill="#A5A9DA"
      />
      <path
        d="m43.76 47.903 3.54-.988s2.678-1.745 3.559 3.441c.88 5.185 5.414 13.251 5.414 13.251l7.76-4.143 3.594 7.86-12.256 7.439-12.906-13.029 1.295-13.831Z"
        fill="#A5A9DA"
      />
      <path
        d="M24.663 86.51a3.422 3.422 0 0 0-1.59-2.414 3.406 3.406 0 0 0-2.868-.329l-7.404-9.619-2.047 5.97 7.345 8.22a3.425 3.425 0 0 0 6.055.56 3.442 3.442 0 0 0 .51-2.388Z"
        fill="#604134"
      />
      <path
        d="m20.182 47.693-2.557-1.814s-5.851-.336-6.702 4.477L.195 68.037l13.301 18.386 6.45-6.802-8.138-9.527 6.832-12.567 1.542-9.834Z"
        fill="#A5A9DA"
      />
      <path
        d="M82.49 50.495h-.135v-3.682a2.135 2.135 0 0 0-1.313-1.97 2.124 2.124 0 0 0-.814-.162H72.44a2.124 2.124 0 0 0-1.966 1.316 2.135 2.135 0 0 0-.161.816v20.201a2.135 2.135 0 0 0 1.313 1.97c.258.107.535.162.814.162h7.787a2.124 2.124 0 0 0 1.965-1.316c.107-.258.162-.536.162-.816V53.117h.134v-2.621Z"
        fill="#020537"
        fillOpacity=".87"
      />
      <path
        d="M80.314 45.236h-1.017a.757.757 0 0 1-.699 1.042h-4.46a.754.754 0 0 1-.7-1.042h-.949a1.587 1.587 0 0 0-1.589 1.592V67a1.593 1.593 0 0 0 1.59 1.591h7.824A1.587 1.587 0 0 0 81.902 67V46.827a1.593 1.593 0 0 0-1.588-1.591Z"
        fill="#FF0080"
      />
      <path
        d="M150.552 38.052H93.449a1.328 1.328 0 0 1-1.328-1.33V1.33A1.334 1.334 0 0 1 93.449 0h57.103a1.328 1.328 0 0 1 1.328 1.33v35.392a1.331 1.331 0 0 1-1.328 1.33Z"
        fill="#fff"
      />
      <path
        d="M150.552 38.052H93.449a1.328 1.328 0 0 1-1.328-1.33V1.33A1.334 1.334 0 0 1 93.449 0h57.103a1.328 1.328 0 0 1 1.328 1.33v35.392a1.331 1.331 0 0 1-1.328 1.33ZM93.449.532a.797.797 0 0 0-.797.798v35.392a.8.8 0 0 0 .797.798h57.103a.799.799 0 0 0 .797-.798V1.33a.8.8 0 0 0-.797-.798H93.449Z"
        fill="#CACDDA"
      />
      <path
        d="M139.265 11.82h-34.528a1.198 1.198 0 0 1 0-2.395h34.528a1.193 1.193 0 0 1 1.195 1.197 1.2 1.2 0 0 1-1.195 1.198ZM139.265 20.069h-34.528a1.197 1.197 0 0 1 0-2.395h34.528a1.194 1.194 0 0 1 1.195 1.197 1.2 1.2 0 0 1-1.195 1.198Z"
        fill="#CACDDA"
      />
      <path
        d="M136.188 33.148a4.276 4.276 0 0 0 4.272-4.28 4.276 4.276 0 0 0-4.272-4.279 4.275 4.275 0 0 0-4.271 4.28 4.275 4.275 0 0 0 4.271 4.279Z"
        fill="#FFE0EA"
      />
      <path d="M90.771 160h-116.24a.305.305 0 0 1 0-.611H90.77a.306.306 0 1 1 0 .611Z" fill="#CACDDA" />
    </g>
    <defs>
      <clipPath id="a">
        <path fill="#fff" transform="translate(.21)" d="M0 0h151.579v160H0z" />
      </clipPath>
    </defs>
  </SvgWrapper>
)

export default PhoneVsDesktopIllustration
